module.exports = __webpack_public_path__ + "img/lighthouse-logo-2022-black.942636de.svg";